/**
 * Maps an input to a object conforming to { city, state }
 * @param {string} addressInput - Input to be mapped
 * @return {object} - Mapped object
 */
function mapAddress(addressInput) {
  if (!addressInput) {
    return {};
  }
  const tokens = addressInput.replace(/\s/g, '').split(',');
  if (tokens.length !== 3) {
    return {};
  }
  return { city: tokens[0], state: tokens[1] };
}

export default mapAddress;
